<template>
  <div class="sectionHeading">
    <div class="line"></div>
    <h4 class="text" v-if="text != ''">{{text}}</h4>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: "sectionHeading",
  props: ["text"]
};
</script>
<style lang="scss" scoped>
.sectionHeading {
  display: flex;
  align-items: center;
  flex-direction: row;
  color: $color1;
  margin: 2.5rem 0;
  @include media-md{
    margin: 3.5rem 0;
  }
  .line {
    background-color: $color2;
    height: 1.5px;
    flex: 1;
  }
  .text {
    padding: 0 15px;
    margin:0;
    font-weight:400;
    color: $color1;
  }
}
</style>
